import { render, staticRenderFns } from "./2512.vue?vue&type=template&id=8c5c42e4&scoped=true"
import script from "./2512.vue?vue&type=script&setup=true&lang=ts"
export * from "./2512.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c42e4",
  null
  
)

export default component.exports